import {
  RETRIEVE_COMMENTS_BEGIN,
  RETRIEVE_COMMENTS_SUCCESS,
  RETRIEVE_COMMENTS_FAILURE,
  FILTER_RETRIEVE_COMMENTS_SUCCESS,
  FILTER_RETRIEVE_COMMENTS_BEGIN,
  FILTER_RETRIEVE_COMMENTS_FAILURE
} from './constants';
import http from '../../../common/http';
import {toast} from "react-toastify";
import { apiEndPoints } from '../../../common/globalConstants';

function generateRetrieveCommentsUrl(props) {
  return `${apiEndPoints.comments.RETRIEVE_COMMENTS}?fromDate=${props.fromDate}&toDate=${
    props.toDate
  }&topicId=${props.topicId}&pageLimit=${props.pageLimit}&pageId=${props.currentPage}&sentiment=${
    props.sentiments && props.sentiments.length ? props.sentiments.join(',').toLowerCase() : 'all'
  }&sources=${
    props.sources && props.sources.length ? props.sources.join(',').toLowerCase() : 'all sources'
  }&sortType=${
    props.sortType
  }&minSarcasmScore=${
    props.minSarcasmScore
  }&maxSarcasmScore=${
    props.maxSarcasmScore
  }&relevance=${
    props.relevanceFilterOption
  }`;
}

export function retrieveAllComments(props = {}) {
  return dispatch => {
    dispatch({
      type: RETRIEVE_COMMENTS_BEGIN,
    });
    const url = generateRetrieveCommentsUrl(props);
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.get(url);
      doRequest.then(
        res => {
          dispatch({
            type: RETRIEVE_COMMENTS_SUCCESS,
            data:
              res.data.status === 200
                ? { count: res.data.count, data: res.data.data }
                : { count: null, data: [] },
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: RETRIEVE_COMMENTS_FAILURE,
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}
export function filterAllComments(props = {}) {
  return dispatch => {
    dispatch({
      type: FILTER_RETRIEVE_COMMENTS_BEGIN,
    });
    const url = generateRetrieveCommentsUrl(props);
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.get(url);
      doRequest.then(
        res => {
          toast.success("Page updated");
          dispatch({
            type: FILTER_RETRIEVE_COMMENTS_SUCCESS,
            data:
              res.data.status === 200
                ? { count: res.data.count, data: res.data.data }
                : { count: null, data: [] },
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: FILTER_RETRIEVE_COMMENTS_FAILURE,
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case RETRIEVE_COMMENTS_BEGIN:
      return {
        ...state,
        retrieveCommentsBegin: true,
        retrieveCommentsSuccess: false,
        retrieveCommentsFailure: false,
      };
    case RETRIEVE_COMMENTS_SUCCESS:
      function commentsStateAlreadyContainsThisReceivedData() {
        if (JSON.stringify(state.allComments.data).includes(JSON.stringify(action.data.data).slice(0,-1))) {
          return true;
        }
        else {
          return false;
        }
      }
      let updatedCommentsData = [];
      if (state.allComments.data && action.data.data && 
        (JSON.stringify(state.allComments.data) !== JSON.stringify(action.data.data)) &&
        (!commentsStateAlreadyContainsThisReceivedData())
        ) {
        updatedCommentsData = [...state.allComments.data, ...action.data.data];
      } else if (action.data.data) {
        updatedCommentsData = action.data.data;
      }
      return {
        ...state,
        retrieveCommentsBegin: false,
        retrieveCommentsSuccess: true,
        allComments: { data: updatedCommentsData, count: action.data.count },
      };
    case RETRIEVE_COMMENTS_FAILURE:
      return {
        ...state,
        retrieveCommentsBegin: false,
        retrieveCommentsFailure: true,
      };
    case FILTER_RETRIEVE_COMMENTS_BEGIN:
      return {
        ...state,
        retrieveCommentsBegin: true,
        retrieveCommentsSuccess: false,
        allComments: {},
      };
    case FILTER_RETRIEVE_COMMENTS_SUCCESS:
      return {
        ...state,
        retrieveCommentsBegin: false,
        retrieveCommentsSuccess: true,
        allComments: { data: action.data.data, count: action.data.count },
      };
    case FILTER_RETRIEVE_COMMENTS_FAILURE:
      return {
        ...state,
        retrieveCommentsBegin: false,
        retrieveCommentsFailure: true,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/retrieveComments.js